/**
 * Custom script to force product gallery refresh when variant changes
 * This ensures the gallery shows the correct variant image + first 3 product images
 */

class ProductGalleryRefresh extends HTMLElement {
  connectedCallback() {
    const form = document.forms[this.getAttribute('form')];
    if (!form) return;

    form.addEventListener('variant:change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    if (!event.detail.variant) return;

    // Force a full rerender of the product-rerender parent
    const productRerender = this.closest('product-rerender');
    if (productRerender) {
      // Trigger a manual rerender by fetching the updated HTML
      this.fetchAndUpdateGallery(event.detail.variant);
    }
  }

  async fetchAndUpdateGallery(variant) {
    const sectionId = this.getAttribute('section-id');
    const productHandle = this.getAttribute('product-handle');
    
    if (!sectionId || !productHandle) return;

    try {
      const url = `${window.Shopify.routes.root}products/${productHandle}?variant=${variant.id}&section_id=${sectionId}`;
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the response
      const tempDoc = new DOMParser().parseFromString(html, 'text/html');
      const newGallery = tempDoc.querySelector('product-gallery');
      const currentGallery = document.querySelector(`product-gallery[form="${this.getAttribute('form')}"]`);
      
      if (newGallery && currentGallery) {
        // Replace the entire gallery
        currentGallery.replaceWith(newGallery);
      }
    } catch (error) {
      console.error('Error refreshing gallery:', error);
    }
  }
}

if (!window.customElements.get('product-gallery-refresh')) {
  window.customElements.define('product-gallery-refresh', ProductGalleryRefresh);
}